import NumSlot0 from '@publishing/assets/icons/events/ff-today/num_slot_0.svg';
import NumSlot1 from '@publishing/assets/icons/events/ff-today/num_slot_1.svg';
import NumSlot2 from '@publishing/assets/icons/events/ff-today/num_slot_2.svg';
import NumSlot3 from '@publishing/assets/icons/events/ff-today/num_slot_3.svg';
import NumSlot4 from '@publishing/assets/icons/events/ff-today/num_slot_4.svg';
import NumSlot5 from '@publishing/assets/icons/events/ff-today/num_slot_5.svg';
import NumSlot6 from '@publishing/assets/icons/events/ff-today/num_slot_6.svg';
import NumSlot7 from '@publishing/assets/icons/events/ff-today/num_slot_7.svg';
import NumSlot8 from '@publishing/assets/icons/events/ff-today/num_slot_8.svg';
import NumSlot9 from '@publishing/assets/icons/events/ff-today/num_slot_9.svg';
import NumTimer0 from '@publishing/assets/icons/events/ff-today/num_timer_0.svg';
import NumTimer1 from '@publishing/assets/icons/events/ff-today/num_timer_1.svg';
import NumTimer2 from '@publishing/assets/icons/events/ff-today/num_timer_2.svg';
import NumTimer3 from '@publishing/assets/icons/events/ff-today/num_timer_3.svg';
import NumTimer4 from '@publishing/assets/icons/events/ff-today/num_timer_4.svg';
import NumTimer5 from '@publishing/assets/icons/events/ff-today/num_timer_5.svg';
import NumTimer6 from '@publishing/assets/icons/events/ff-today/num_timer_6.svg';
import NumTimer7 from '@publishing/assets/icons/events/ff-today/num_timer_7.svg';
import NumTimer8 from '@publishing/assets/icons/events/ff-today/num_timer_8.svg';
import NumTimer9 from '@publishing/assets/icons/events/ff-today/num_timer_9.svg';

export const NUM_SLOT_ICONS = [
  NumSlot0, NumSlot1, NumSlot2, NumSlot3, NumSlot4,
  NumSlot5, NumSlot6, NumSlot7, NumSlot8, NumSlot9,
] as const;

export const NUM_TIMER_ICONS = [
  NumTimer0, NumTimer1, NumTimer2, NumTimer3, NumTimer4,
  NumTimer5, NumTimer6, NumTimer7, NumTimer8, NumTimer9,
] as const;
